export default function MobileNav({ children }: { children: React.ReactNode }) {
  return (
    <div
      className="
        md:hidden
        fixed left-0 right-0 bottom-0
        z-50
        flex justify-center
        pointer-events-none
      "
    >
      <div
        className="
          w-full max-w-lg mx-auto
          pointer-events-auto
          bg-gray-950/80
          backdrop-blur-xl
          border-t border-white/10
          shadow-[0_-4px_18px_rgba(0,0,0,0.45)]
          rounded-t-2xl
          flex justify-between items-center
          px-6 py-3
        "
        style={{
          paddingBottom: "env(safe-area-inset-bottom)", // только для iPhone
        }}
      >
        {children}
      </div>
    </div>
  );
}
